(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})((typeof self !== "undefined" ? self : this), function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./loader.ts");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./loader.ts":
/*!*******************!*\
  !*** ./loader.ts ***!
  \*******************/
/*! exports provided: loadGAEditorSDK, getEditorSDKurl */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadGAEditorSDK", function() { return loadGAEditorSDK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEditorSDKurl", function() { return getEditorSDKurl; });
function getEditorSDKForVersion(version) {
  var urlBase = "https://static.parastorage.com/services/js-platform-editor-sdk/".concat(version, "/");
  return new URL('lib/editorSDK.min.js', urlBase).toString();
}

function isUrlAllowed(sdkVersion) {
  var url;

  try {
    url = new URL(sdkVersion);
  } catch (e) {
    return false;
  }

  var isLocalhost = url.hostname === 'localhost' || url.hostname.endsWith('.localhost');

  if (isLocalhost) {
    return true;
  }

  var isEditorSDKFromParastorage = url.hostname === 'static.parastorage.com' && url.protocol === 'https:' && (url.pathname.startsWith('/services/js-platform-editor-sdk/') || url.pathname.startsWith('/unpkg/@wix/platform-editor-sdk@'));

  if (isEditorSDKFromParastorage) {
    return true;
  }

  return false;
}

function getEditorSDKurl(currentUrl) {
  if (typeof currentUrl === 'string') {
    currentUrl = new URL(currentUrl);
  }

  var sdkVersion = currentUrl.searchParams.get('sdkVersion') || currentUrl.searchParams.get('wix-sdk-version');
  var editorSdkVersion = currentUrl.searchParams.get('editorSdkVersion');

  if (sdkVersion === null || sdkVersion === void 0 ? void 0 : sdkVersion.match(/^[0-9]+\.[0-9]+\.[0-9]+$/)) {
    return getEditorSDKForVersion(sdkVersion);
  } else if (sdkVersion && isUrlAllowed(sdkVersion)) {
    return new URL(sdkVersion).toString();
  } else if (editorSdkVersion === null || editorSdkVersion === void 0 ? void 0 : editorSdkVersion.match(/^[0-9]+\.[0-9]+\.[0-9]+$/)) {
    return getEditorSDKForVersion(editorSdkVersion);
  } else if (true) {
    return getEditorSDKForVersion("1.1558.0");
  } // this should *never* happen, but in case it does...


  return getEditorSDKForVersion('1.1352.0');
}

function loadGAEditorSDK() {
  var editorSDKurl = getEditorSDKurl(new URL(self.location.href));
  return new Promise(function (resolve, reject) {
    if (window.editorSDK) {
      resolve(window.editorSDK);
      return;
    }

    var onload = function onload() {
      resolve(window.editorSDK);
    };

    var onerror = function onerror(event) {
      reject(new Error(event.error || event));
    };

    var existingScript = document.querySelector("script[src=\"".concat(editorSDKurl, "\"]"));

    if (existingScript) {
      existingScript.onload = onload;
      existingScript.onerror = onerror;
      return;
    }

    var script = document.createElement('script');
    script.onload = onload;
    script.onerror = onerror;
    script.src = editorSDKurl;
    document.body.appendChild(script);
  });
}



/***/ })

/******/ });
});